import { Center, Spinner } from '@chakra-ui/react';
import { ReactNode } from 'react';

import { LoginPage } from '#src/pages/login';
import { useUser } from '#src/providers/user-provider';

interface AuthGuardProps {
  children: ReactNode;
}

/**
 * Renders children only when the user is authenticated (valid JWT cookie).
 * Shows login page when not authenticated, and a loading state while checking.
 */
export function AuthGuard({ children }: AuthGuardProps) {
  const { user, loading } = useUser();

  if (loading) {
    return (
      <Center minH="100vh">
        <Spinner size="xl" />
      </Center>
    );
  }

  if (!user) {
    return <LoginPage />;
  }

  return <>{children}</>;
}
